import {
  FETCH_FAQS_DATA,
  FETCH_FAQS_SUCCESS,
  FETCH_FAQS_FAILURE,
  FETCH_FAQS_EDIT_DATA,
  FETCH_FAQS_EDIT_SUCCESS,
  FETCH_FAQS_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const faqs = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAQS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_FAQS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_FAQS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_FAQS_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_FAQS_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_FAQS_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default faqs;
